<template>
  <el-popover
    v-if="num_of_invitations_outgoing > 0"
    placement="right"
    width="500"
    ref="outgoing_invitation_popover"
    trigger="click">

    <div class="p-0" @resize="onResize">
      <h5>Outgoing invitations</h5>
      <ul style="/*list-style: disc; padding-left: 18px;*/" class="p-0">
        <InlineOutgoingInvitation
          v-for="invitation in outgoing_invitations.itemsAsArray()"
          :key="invitation.$key"
          :invitation="invitation" />
      </ul>

      <el-button @click="onInviteClick">Invite to Goalpilot</el-button>
    </div>

    <a slot="reference" class="menubar-link" style="width: 160px; padding-right: 0;">
      show {{num_of_invitations_outgoing}} outgoing invitations
    </a>

  </el-popover>
</template>

<script>
import InlineOutgoingInvitation from '@/components/Inline/InlineOutgoingInvitation'
import InvitePromptMixin from '@/components/Mixins/Prompts/InvitePrompt'

export default {
  mixins: [ InvitePromptMixin ],
  data() {
    return {
      invite_dialog_visible: false,
    };
  },
  computed: {
    num_of_invitations_outgoing() {
      return this.outgoing_invitations.$id_list.length
    },
    outgoing_invitations() {
      return this.$models.userOutgoingInvitation.subscribeList()
    },
  },
  methods: {
    onInviteClick() {
      this.$invite_prompt({
        type: 'Goalpilot'
      })
    },
    onResize(value) {
      let popover = this.$refs.outgoing_invitation_popover.$refs.popper;
      popover.style.top = ( parseFloat(popover.style.top) + value ) + 'px';
      // TODO: Also fix arrow
    },
  },
  components: {
    InlineOutgoingInvitation,
  }
};
</script>
